import { Badge } from "@chakra-ui/react"

export default Badge